

import { Component, Inject, OnInit, Input, EventEmitter, OnDestroy, ViewChild, OnChanges, SimpleChanges, SimpleChange, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { TableList } from 'shtools';
import { Table } from 'primeng/table';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { PanelType } from 'solar-bo';



@Component({
  selector: 'app-paneltype-select-list',
  templateUrl: './paneltype-select-list.component.html',
  styleUrls: ['./paneltype-select-list.component.scss']
})
export class PanelTypeSelectListComponent extends SolarBaseComponent implements OnInit {

 
  list: PanelType[]=[];
  @Output() panelTypeSelectedEvent:EventEmitter<PanelType>=new EventEmitter();

  
  @ViewChild("frtable") frtable: Table;
  tdata = new TableList<PanelType>();

  get listFiltered(): any[] {
    return this.tdata.filteredData;
  }

  constructor(   
    ) {
      super();      
  }



  ngOnInit() {
      this.getList();
  }

  getList(): void {
    this.listerrmessage = "";
    this.loadinglist = true;
    this.solarService.PanelsTypesList()
      .subscribe(
        reslist => this.getListHandleresult(reslist)
        , err => this.getListHandleError(err)
      );
  }

  private getListHandleresult(list: PanelType[]) {
    this.listerrmessage = "";
    this.loadinglist = false;
    this.list = list;
    this.tdata.data = list;
  }

  private getListHandleError<T>(err: any) {
    this.loadinglist = false;
    this.handleError(err, "Error retrieving supervisions list");
  }

  tableFilter($event) {
    this.frtable.filterGlobal($event.target.value, 'contains');
  }

  openitem(item:PanelType){
    this.panelTypeSelectedEvent.emit(item);    
  }

  public static openDialog(dialog: MatDialog): MatDialogRef<PanelTypeSelectListComponent> {

    let dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "600px";


    dialogConfig.data = { component: PanelTypeSelectListComponent  };
    return dialog.open(PanelTypeSelectListComponent, dialogConfig);

  }

}
